/* eslint-disable max-len */
import React from 'react';
function ManagerDashboardOutlined() {
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 3H19C20.1 3 21 3.9 21 5V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3ZM5 19H19V5H5V19ZM11.0001 7H13.0001V17H11.0001V7ZM7 10H9V17H7V10ZM17 13H15V17H17V13Z" })));
}
export default ManagerDashboardOutlined;
